(() => {
  const artwork = 'https://cdn.shopify.com/s/files/1/1000/7966/5490/files/vv-phone-reading-cinematic.png?v=1788973908';

  const replacePhoneArtwork = () => {
    document.querySelectorAll('img[src*="vv-phone-readings"]').forEach((image) => {
      image.src = artwork;
      image.removeAttribute('srcset');
    });

    const media = document.querySelector('.mp-product-media img[src*="vv-phone-reading-cinematic"]')?.closest('.mp-product-media');
    if (!media || media.classList.contains('vv-phone-motion')) return;

    media.classList.add('vv-phone-motion');

    const atmosphere = document.createElement('span');
    atmosphere.className = 'vv-phone-atmosphere';
    atmosphere.setAttribute('aria-hidden', 'true');

    const candleGlow = document.createElement('span');
    candleGlow.className = 'vv-phone-candle-glow';
    candleGlow.setAttribute('aria-hidden', 'true');

    const sparkles = document.createElement('span');
    sparkles.className = 'vv-phone-safe-sparkles';
    sparkles.setAttribute('aria-hidden', 'true');
    for (let index = 1; index <= 5; index += 1) {
      const star = document.createElement('i');
      star.className = `vv-phone-star vv-phone-star--${index}`;
      sparkles.appendChild(star);
    }

    media.append(atmosphere, candleGlow, sparkles);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replacePhoneArtwork, { once: true });
  } else {
    replacePhoneArtwork();
  }
})();
